export default "__VITE_ASSET__B7TGX69L__"